import apiClient from './client';

/**
 * Submit a landing-page access request.
 *
 * There is no self-service signup: this only records the request and pings
 * support, who create the tenant by hand. Rejects on failure so the caller can
 * show an error instead of a success it did not earn.
 *
 * @param {{email: string, source: 'hero'|'cta', company?: string}} data
 */
export async function createPreRegistration({ email, source, company = '' }) {
  const { data } = await apiClient.post('/api/v1/auth/pre-registration/', {
    email,
    source,
    company,
    // Honeypot: real users never see this field, bots fill it in.
    company_website: '',
  });
  return data;
}

export default createPreRegistration;
